import React from 'react';

interface AdaptiveLogoProps {
    className?: string;
    width?: number;
    height?: number;
}

export const AdaptiveLogo: React.FC<AdaptiveLogoProps> = ({
    className = "",
    width = 30,
    height = 32
}) => {
    return (
        <svg
            width={ width }
            height={ height }
            viewBox="0 0 30 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={ className }
        >
            <defs>
                <linearGradient id="paint0_light" x1="9.21402" y1="-4.20811e-08" x2="14.8112" y2="20.3646" gradientUnits="userSpaceOnUse">
                    <stop offset="0.333333" stop-color="#3794EB" />
                    <stop offset="1" stop-color="#000272" />
                </linearGradient>
            </defs>
            <path
                d="M13.046 29.0058C13.7629 27.7883 13.6053 26.4637 13.594 25.1687C13.5903 24.844 13.7028 24.6743 13.9843 24.5157C17.6437 22.4496 21.303 20.3761 24.9549 18.2952C25.8219 17.8008 26.4449 17.1293 26.4974 16.0741C26.55 14.9341 25.8782 14.2441 24.9699 13.7239C22.5341 12.3293 20.087 10.9494 17.6474 9.56586C14.2771 7.65102 10.8955 5.75462 7.53263 3.82132C5.82118 2.83623 3.92958 3.86928 3.57302 5.38936C3.50922 5.65869 3.50171 5.94278 3.49796 6.21949C3.49045 12.7979 3.4867 19.3799 3.4867 25.962C3.4867 27.0356 3.99713 27.8141 4.95795 28.3011C5.89249 28.777 6.78199 28.6405 7.59268 28.0244C8.2645 27.5116 8.53473 26.7847 8.53473 25.9693C8.53848 20.7598 8.53473 15.5502 8.53473 10.3407C8.53473 10.1636 8.53473 9.99015 8.53473 9.71713C12.3029 11.8497 16.0035 13.9416 19.7605 16.0667C19.6291 16.1553 19.5315 16.2254 19.4264 16.2881C18.4957 16.8157 17.5574 17.3286 16.6416 17.882C16.3789 18.0406 16.2025 18.0185 15.9548 17.8746C14.7875 17.1957 13.6053 16.539 12.4268 15.8749C12.3029 15.8048 12.1716 15.7458 11.9839 15.6572C11.9839 15.8564 11.9839 15.9966 11.9839 16.1405C11.9839 19.5201 11.9801 22.8997 11.9801 26.2793C11.9801 28.8545 9.9234 31.3007 7.35623 31.8615C3.82073 32.6326 0.480407 30.0758 0.0788167 26.8954C0.0412849 26.6039 0 26.3125 0 26.021C0 19.3135 0 12.6134 0 5.91326C0 3.21993 2.08301 0.70739 4.77029 0.146587C6.36164 -0.189157 7.84414 0.0543498 9.25158 0.85128C15.0878 4.16444 20.9352 7.46285 26.7677 10.7908C28.3102 11.6689 29.4249 12.9196 29.8378 14.6795C30.3144 16.7087 29.7177 18.4428 28.3515 19.9702C27.4695 20.9553 26.2797 21.5014 25.1575 22.1397C21.2092 24.3866 17.2534 26.6298 13.3013 28.873C13.2187 28.9136 13.1324 28.9578 13.046 29.0058Z"
                className="fill-[url(#paint0_light)] dark:fill-white"
            />
        </svg>
    );
}; 